<template>
  <div>
    <div v-if="!isEnded">
      {{ this.$store.state.user.userInfo.fullName }}
      <div class="countdown" style="font-size:48px">{{ timeText }}</div>
      <div v-if="start">
        <vue-jitsi-meet
          ref="jitsiRef"
          domain="meet.jit.si"
          :options="jitsiOptions"
        ></vue-jitsi-meet>
      </div>
    </div>
    <div v-else><h3>Хурал дууссан байна</h3></div>
  </div>
</template>
<script>
import { JitsiMeet } from "@mycure/vue-jitsi-meet";
import { request } from "@/api/all";

var myVar;

export default {
  components: {
    VueJitsiMeet: JitsiMeet
  },
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEnded: true,
      start: false,
      timeText: "",
      displayName: ""
    };
  },
  mounted() {
    this.displayName =
      this.$store.state.user.userInfo.fullName +
      " " +
      Math.floor(Math.random() * Math.floor(999));

    request({
      api: { url: "servertime", method: "get" },
      store: self.$store
    }).then(res => {
      if (res != false) {
        //console.log(res.data.now);
        if (res.data.now >= this.task.dueDate) this.isEnded = true;
        else this.isEnded = false;
        if (res.data.now < this.task.dueStartDate) this.timeLoader();
        else if (!this.isEnded) this.startVideo();
      }
    });
  },
  methods: {
    startVideo() {
      this.timeText = "";
      this.start = true;
    },
    timeLoader() {
      let interval = 1000;
      let self = this;
      myVar = setInterval(function() {
        request({
          api: { url: "Public/TimeDiffFromNow", method: "get" },
          params: {
            date: self.task.dueStartDate
          },
          store: self.$store
        }).then(res => {
          if (res != false) {
            if (res.data.diff > 0) {
              self.timeText =
                (Math.floor(res.data.diff / 60) + "").padStart(2, "0") +
                "минут : " +
                (Math.floor(res.data.diff % 60) + "").padStart(2, "0") +
                "сек";
            } else {
              clearTimeout(myVar);
              self.startVideo();
            }
          } else {
            // do res ! false do anything
          }
        });
      }, interval);
    },
    onIFrameLoad() {
      // do stuff
    }
  },
  computed: {
    jitsiOptions() {
      return {
        roomName: this.task.task + "-" + this.task.id,
        height: 600,
        noSSL: false,
        userInfo: {
          email: this.$store.state.user.userInfo.mail,
          displayName: this.displayName
        },
        configOverwrite: {
          enableNoisyMicDetection: false
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false
        },
        onload: this.onIFrameLoad
      };
    }
  }
};
</script>
